
export class URLUtils {
    //Get department
    //static department = `/departments/uid`

    static support(args: any) {
        return `/support/${args}`;
    }

    static departments(args: any) {
        return `/departments/${args}`
        //return `http://localhost:4200/support?uid=${args}`
    }
    static complaints(args: any) {
        return `/compliants/${args}`;
    }
    static nps(args: any) {
        return `/nps/pre/${args}`;
    }

    /**
     * Dynamic feedback configuration endpoint: GET /questions/{firmName}
     * firmName comes from the route (already decoded by Angular's ActivatedRoute),
     * so it is re-encoded here before going back onto the wire — this avoids both
     * double-encoding (encoding an already-encoded string) and literal special
     * characters (&, #, ?, /) breaking the request path.
     */
    static questions(args: any): string {
        const safeArg = args === null || args === undefined ? '' : String(args);
        return `/questions/${encodeURIComponent(safeArg)}`;
    }
}
